<div class="header">
  <button mat-icon-button class="btn-close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <h3>
    @let id_alumnis = form_alta.controls.id_alumnis.value;

    @if (id_alumnis && id_alumnis !== 0) {
    <span i18n="@@Editar Alumno">Editar Alumno ({{id_alumnis}})</span>
    } @else {
    <span i18n="@@Creación de Alumno">Creación de Alumno</span>
    }
  </h3>
</div>

<section class="main">
  <form [formGroup]="form_alta" class="form full-width">
    <ng-template #stdField let-field_label="label" let-field_formname="formname" let-required="required">
      @if (!forbidden_columns.includes(field_formname)) {
				@let control = form_alta.get(field_formname);

        <mat-form-field class="fcontrol" appearance="outline">
          <mat-label>{{field_label}}</mat-label>
          <input matInput [placeholder]="field_label" i18n-placeholder
            [formControl]="$any(control)">

					@if (control?.touched && control?.errors; as errs) {
						<mat-hint class="error-text">
							
							@switch (true) {
								@case (errs['required']) {
									<span i18n="@@Obligatorio">Obligatorio</span>
								}
								@case (errs['DNIAlreadyExists']) {
									<span i18n="@@Este DNI ya está registrado">Este DNI ya está registrado</span>
								}
								@case (errs['NumColegiadoAlreadyExists']) {
									<span i18n="@@Este número de colegiado ya exite">Este número de colegiado ya exite</span>
								}
								<!-- Puedes seguir añadiendo casos aquí abajo si el formulario crece -->
							}
						</mat-hint>
					}
				
        </mat-form-field>
      }
    </ng-template>
    <ng-template #optionsField let-field_label="label" let-field_formname="formname" let-required="required"
      let-options_list="options_list">
      <!--
      Añade una opción en blanco => Vacía
      Entrada es un string[]
      El valor y la descripción son iguales
      -->
      @if (!forbidden_columns.includes(field_formname)) {
      <mat-form-field class="fcontrol" appearance="outline">
        <mat-label>{{field_label}}</mat-label>
        <mat-select [formControlName]="field_formname">
          <!-- (selectionChange)="checkfilter($event, col_name)" -->
          <mat-option value=""></mat-option>
          @for (item of options_list; track item) {
          <mat-option [value]="item">
            {{item}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
    </ng-template>
    <ng-template #optionsField2 let-field_label="label" let-field_formname="formname" let-required="required"
      let-options_list="options_list">
      <!--
      Añade una oopción en blanco => Vacía
      Entrada es un string[]
      El valor es el indice, la descripción es el contenido
      -->
      @if (!forbidden_columns.includes(field_formname)) {
      <mat-form-field class="fcontrol" appearance="outline">
        <mat-label>{{field_label}}</mat-label>
        <mat-select [formControlName]="field_formname">
          @for (item of options_list; track item; let i = $index) {
          <mat-option [value]="i">
            {{item}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
    </ng-template>
    <ng-template #emailField let-field_label="label" let-field_formname="formname" let-required="required">
      @if (!forbidden_columns.includes(field_formname)) {
      <mat-form-field class="fcontrol" appearance="outline">
        <mat-label>{{field_label}}</mat-label>
        <input matInput [placeholder]="field_label" i18n-placeholder [formControlName]="field_formname">
        @if (required) {
        @if (form_alta.get(field_formname)!.touched &&
        (form_alta.get(field_formname)!.errors &&
        form_alta.get(field_formname)!.errors!['required'])) {
        <mat-hint class="error-text">
          <span i18n>Required</span>
        </mat-hint>
        }
        }
        @if (form_alta.get(field_formname)!.touched &&
        (form_alta.get(field_formname)!.errors &&
        form_alta.get(field_formname)!.errors!['pattern'])) {
        <mat-hint class="error-text">
          <span i18n>Invalid mail</span>
        </mat-hint>
        }
      </mat-form-field>
      }
    </ng-template>
    <ng-template #boolField1 let-field_label="label" let-field_formname="formname">
      @if (!forbidden_columns.includes(field_formname)) {
      <mat-slide-toggle [formControlName]="field_formname">
        <mat-label>{{field_label}}</mat-label>
      </mat-slide-toggle>
      }
    </ng-template>
    <ng-template #dateField let-field_label="label" let-field_formname="formname" let-required="required">

      @if (!forbidden_columns.includes(field_formname)) {
      @let control = form_alta.get(field_formname);
      <p><span i18n="@@fecha">Fecha</span>:</p>
      <mat-form-field class="fcontrol" appearance="outline">
        <mat-label><span i18n="@@fecha">Fecha</span> {{field_label}}</mat-label>

        <!-- [matTimepicker]="timePicker" -->
        <input matInput [matDatepicker]="datePicker" [placeholder]="field_label" [formControlName]="field_formname">

        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <!-- <mat-timepicker-toggle matSuffix [for]="timePicker"></mat-timepicker-toggle> -->

        <mat-datepicker #datePicker></mat-datepicker>
        <!-- <mat-timepicker #timePicker></mat-timepicker> -->

        @if (required && control?.touched && control?.hasError('required')) {
        <mat-hint class="error-text">
          <span i18n>Required</span>
        </mat-hint>
        }
      </mat-form-field>
      }
    </ng-template>
    <ng-template #timeField let-field_label="label" let-field_formname="formname" let-required="required">

      @if (!forbidden_columns.includes(field_formname)) {
      @let control = form_alta.get(field_formname);
      <p i18n="@@hora">Hora</p>

      <mat-form-field class="fcontrol" appearance="outline">
        <mat-label><span i18n="@@hora">Hora</span> {{field_label}}</mat-label>

        <!-- [matTimepicker]="timePicker" -->
        <input matInput [matTimepicker]="timePicker" [placeholder]="field_label" [formControlName]="field_formname">

        <mat-timepicker-toggle matSuffix [for]="timePicker"></mat-timepicker-toggle>
        <!-- <mat-timepicker-toggle matSuffix [for]="timePicker"></mat-timepicker-toggle> -->

        <mat-timepicker #timePicker></mat-timepicker>
        <!-- <mat-timepicker #timePicker></mat-timepicker> -->

        @if (required && control?.touched && control?.hasError('required')) {
        <mat-hint class="error-text">
          <span i18n>Required</span>
        </mat-hint>
        }
      </mat-form-field>
      }
    </ng-template>
    <ng-template #datetimeField let-field_label="label" let-field_formname="formname" let-required="required">
      @if (!forbidden_columns.includes(field_formname)) {
      <div class="datetime_container">
        <ng-container *ngTemplateOutlet="dateField;context:{
                label: field_label,
                formname: field_formname, 
                required: required}"></ng-container>
        <ng-container *ngTemplateOutlet="timeField;context:{
                label: field_label,
                formname: field_formname, 
                required: required}"></ng-container>
      </div>
      }
    </ng-template>
    <ng-template #textAreaField let-field_label="label" let-field_formname="formname" let-required="required">
      @if (!forbidden_columns.includes(field_formname)) {
      @let ctrl = form_alta.get(field_formname) || null;

      <mat-form-field class="fcontrol" appearance="outline">
        <mat-label>{{field_label}}</mat-label>
        <textarea matInput [placeholder]="field_label" i18n-placeholder [formControlName]="field_formname"></textarea>
        @if (required) {
        @if (ctrl?.touched && (ctrl?.errors && ctrl?.errors!['required'])) {
        <mat-hint class="error-text">
          <span i18n>Required</span>
        </mat-hint>
        }
        }
      </mat-form-field>
      }
    </ng-template>
    <ng-template #numberField let-field_label="label" let-field_formname="formname" let-required="required">
      @if (!forbidden_columns.includes(field_formname)) {
      @let ctrl = form_alta.get(field_formname) || null;

      <mat-form-field class="fcontrol" appearance="outline">
        <mat-label>{{field_label}}</mat-label>
        <input type="number" matInput [placeholder]="field_label" i18n-placeholder [formControlName]="field_formname">
        @if (required) {
        @if (ctrl?.touched && (ctrl?.errors && ctrl?.errors!['required'])) {
        <mat-hint class="error-text">
          <span i18n>Required</span>
        </mat-hint>
        }
        }
      </mat-form-field>
      }
    </ng-template>





    <mat-form-field class="left-column fcontrol" appearance="outline" style="display: none;">
      <mat-label>ID</mat-label>
      <input matInput placeholder="Id" i18n-placeholder formControlName="id_alumnis">
    </mat-form-field>
    <!-- <mat-form-field class="left-column fcontrol" appearance="outline">
      <mat-label>Fecha Alta</mat-label>
      <input matInput placeholder="Fecha Alta" readonly i18n-placeholder formControlName="fecha_alta">
    </mat-form-field> -->
    <div>
      <span i18n="@@fecha_alta">Fecha alta</span>: {{form_alta.get('fecha_alta')?.value | date:'dd/MM/yyyy'}}
    </div>
    <!-- <div class="right-column">
      <ng-container
        *ngTemplateOutlet="datetimeField;context:{label: 'Fecha Alta', formname: 'fecha_alta', required: false}"></ng-container><br />
    </div> -->
    <fieldset>
      <legend><span i18n="@@datos_basicos">Datos básicos</span></legend>
      <ul>
        <li>
          <div class="left-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Nº Colegiado', formname: 'num_colegiado', required: true}"></ng-container><br />
          </div>

        </li>
        <li>
          @if (puedoVerDNI()) {
          <div class="right-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'DNI-CIF', formname: 'dni', required: true}"></ng-container><br />
          </div>
          }
          <div class="right-column">
            <ng-container
              *ngTemplateOutlet="numberField;context:{label: 'Año Master', formname: 'ano_master', required: true}"></ng-container><br />
          </div>
        </li>
        <li>
          <div class="right-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Nombre', formname: 'nombre', required: true}"></ng-container><br />
          </div>
        </li>
        <li>
          <div class="left-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Apellido 1', formname: 'apellido1', required: true}"></ng-container><br />
          </div>
          <div class="right-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Apellido 2', formname: 'apellido2', required: false}"></ng-container><br />
          </div>
        </li>
        <li>
          <div class="left-column">
            <ng-container
              *ngTemplateOutlet="emailField;context:{label: 'eMail', formname: 'email', required: false}"></ng-container><br />
          </div>
          <div class="right-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Teléfono', formname: 'telefono', required: false}"></ng-container><br />
          </div>
        </li>
      </ul>
    </fieldset>
    <fieldset>
      <legend>Datos Empresa</legend>
      <ul>
        <li>
          <div class="left-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Empresa', formname: 'empresa', required: false}"></ng-container><br />
          </div>
          <div class="right-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'NIF empresa', formname: 'nif_empresa', required: true}"></ng-container><br />
          </div>
        </li>
        <li>
          <div class="left-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Cargo', formname: 'cargo', required: false}"></ng-container><br />
          </div>
          <div class="right-column">
            <ng-container
              *ngTemplateOutlet="optionsField;context:{label: 'Tipo empresa', formname: 'tipo_empresa', options_list: tipos_empresas,required: false}"></ng-container><br />
          </div>
        </li>
      </ul>
    </fieldset>
    <fieldset>
      <legend>Dirección postal</legend>
      <ul>
        <li>
          <div class="left-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Dirección', formname: 'direccion', required: false}"></ng-container><br />
          </div>
          <div class="right-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Código Postal', formname: 'codigo_postal', required: false}"></ng-container><br />
          </div>
        </li>
        <li>
          <div class="left-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'Ciudad', formname: 'ciudad', required: false}"></ng-container><br />
          </div>
          <!-- <div class="right-column">
            <ng-container
              *ngTemplateOutlet="stdField;context:{label: 'País', formname: 'pais', required: false}"></ng-container><br />
          </div> -->
        </li>
        <li class="full-width">
          <div class="full-width">
            <ng-container
              *ngTemplateOutlet="textAreaField;context:{label: 'Especialización', formname: 'especializacion', required: false}"></ng-container><br />
          </div>

        </li>
      </ul>
    </fieldset>

    <div class="internal-controls">
      <!--            {{getErrors()|json}}
      <code><pre>{{form_alta.value|json}}</pre></code>-->
    </div>
  </form>
  <!-- <div class="debug">
    <pre>{{form_alta.value|json}}</pre>
    //TODO: Añadir listado de campos mostrando sus errores
  </div> -->

  @if (form_alta.invalid) {
  <div class="error-container">
    <h3>Errores en el formulario:</h3>

    @for (control of form_alta.controls | keyvalue; track control.key) {
      @if (control.value.errors) {
      <div>
        <strong>{{ control.key }}:</strong>
        @for (error of control.value.errors | keyvalue; track error.key) {
        <div>{{ error.key | titlecase }}</div>
        }
      </div>
      }
    }
  </div>
  }
</section>

<div class="footer">
  @if (!read_only) {
  <nav class="page-nav">
    <button mat-flat-button mat-dialog-close color="warn">
      <span i18n="@@cancelar">Cancelar</span>
    </button>
    <button mat-flat-button color="primary" (click)="onSaveClose()" [disabled]="form_alta.invalid">
      <span i18n="@@guardar">Guardar</span>
    </button>
  </nav>
  } @else {
  <nav class="page-nav">
    <button mat-flat-button mat-dialog-close color="primary">
      <span i18n="@@cerrar">Cerrar</span>
    </button>
  </nav>
  }
</div>